/* eslint-disable complexity */
/* eslint-disable max-depth */
import {CommentContentType, MentionType} from '@/constants/document/comment';

const COMMENT_KEY_PREFIX = 'comment_id-';

interface CommentObj {
    [propsName: string]: any;
}

/**
 * 获取划线评论总数
 * @param domTree 文档 dom 结构树
 * @param commentObj 划线评论对象
 * @returns
 */
export function getUnderLineCommentCount(domTree: any[], commentObj: CommentObj): number {
    if (!Array.isArray(domTree) || !commentObj) {
        return 0;
    }

    const keySet = new Set<string>();
    const stack = [...domTree];
    // 遍历文章 dom 树，获取值为 true 的划线评论 key 值
    while (stack.length > 0) {
        const node = stack.pop();
        if (!node) {
            continue;
        }
        Object.keys(node).forEach((key: string) => {
            if (key.startsWith(COMMENT_KEY_PREFIX) && node[key] === true) {
                keySet.add(key.substring(COMMENT_KEY_PREFIX.length));
            }
        });

        if (Array.isArray(node.children)) {
            node.children.forEach((el: any) => {
                stack.push(el);
            });
        }
    }
    // 将划线评论对象，和文档 dom 结构树中的划线评论取交集，再计算最终的评论数
    let length = 0;
    keySet.forEach((key: string) => {
        const commentItem = commentObj[key];
        if (commentItem) {
            length += commentItem.commentList.length;
        }
    });
    return length;
}

/**
 * 编辑器 JSON 结构转字符串（用于展示）
 */
export const getStringByJSON = (json: any) => {
    if (!Array.isArray(json)) {
        return '';
    }

    let str = '';
    try {
        const stack = [...json];
        // 深度优先遍历 JSON
        while (stack.length > 0) {
            const node = stack.shift();
            if (!node) {
                continue;
            }
            const {text, type, mentionType, mentionName, title} = node;
            if (type === CommentContentType.Mention) {
                if (mentionType === MentionType.Contact) {
                    str += `@${mentionName || ''}`;
                }
                if (mentionType === MentionType.Doc) {
                    str += mentionName || '';
                }
            } else if (type === CommentContentType.Link) {
                str += title || '';
                continue; // link 特殊处理，不需要再遍历子节点
            } else if (type === CommentContentType.Image) { // 图片回复显示[图片]
                str += '[图片]';
            } else {
                str += text || '';
            }

            if (Array.isArray(node.children)) {
                [...node.children].reverse().forEach((el: any) => {
                    stack.unshift(el);
                });
            }
        }
    } catch {
        str = '';
    }
    return str;
};

/**
 * 底部评论数据转字符串，兼容新旧数据
 */
export const getCommentString = (comment?: string): string => {
    if (!comment) {
        return '';
    }

    let str = '';
    try {
        const json = JSON.parse(comment);
        if (json && typeof json === 'object') {
            str = getStringByJSON(json);
        } else {
            str = comment;
        }
    } catch {
        str = comment;
    }
    return str;
};
